import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Menu } from 'lucide-react';

export default function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Close mobile sidebar on route change
  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-cream">
      {/* Mobile top bar */}
      <div className="lg:hidden fixed top-0 inset-x-0 h-14 bg-taupe text-cream z-30 flex items-center justify-between px-4 shadow-md">
        <button
          onClick={() => setMobileOpen(true)}
          className="p-2"
          aria-label="Open menu"
          data-testid="mobile-menu-btn"
        >
          <Menu size={22} />
        </button>
        <span className="font-display text-lg tracking-widest text-[var(--color-gold-light)]">VALTHELIS</span>
        <span className="w-8" />
      </div>

      {/* Backdrop for mobile sidebar */}
      {mobileOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-30"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      <Sidebar isMobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />

      {/* Main content */}
      <main
        className="lg:ml-[270px] pt-14 lg:pt-0 min-h-screen relative"
        data-testid="main-content"
      >
        <Outlet />
      </main>
    </div>
  );
}
